import React, {FC} from 'react';
import styled from 'styled-components';

import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {inboxHasColor} from '../../../helpers/modelHelpers';
import {InboxModel} from '../../../models/api/inboxModel';
import {ColorDot} from '../colorDot';

/*
 * Props.
 */

interface DropdownItemInboxDotProps {
  inbox: InboxModel;
}

/*
 * Style.
 */

const StyledColorDotDiv = styled.div`
  padding: 7px 12px 7px 4px;
  grid-area: left-icon;
`;

/*
 * Component.
 */

export const DropdownItemInboxDot: FC<DropdownItemInboxDotProps> = ({inbox}) => {
  const theme = useUserTheme();
  // We do not want to display nothing when the inbox has no color
  // because we potentially have a weird margin otherwise.
  const color = inboxHasColor(inbox) ? inbox.color : theme.greys.shade50;

  return (
    <StyledColorDotDiv>
      <ColorDot color={color} size={8} />
    </StyledColorDotDiv>
  );
};
